import React from "react";
import styled from "styled-components";

const Wrapper = styled.section`
  margin: 0 auto;
  max-width: ${props => props.theme.sizes.maxWidth};
  width: 100%;
  padding: ${props => (props.inSmallHeader ? "3em 2em 1em" : "3em 2em 2em")};
  
  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    padding: ${props => (props.inSmallHeader ? "8em 4em 0" : "3em 4em 4em")};
  }
  
  @media screen and (min-width: ${props => props.theme.responsive.large}) {
    padding: 3em 0 2em;
  }
`;

const Container = props => {
  return <Wrapper inSmallHeader={props.inSmallHeader}>{props.children}</Wrapper>;
};

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container.js